export class CreateUserError extends Error {}
